export default __webpack_public_path__ + "da00a348b43a3a2c02f4b3aa1b4f8560.mp4";